export function getItem(storage) {
  return function execute(key) {
    if (storage && storage.getItem) {
      return storage.getItem(key);
    }
    return null;
  };
}
const localStorage = window && window.localStorage ? window.localStorage : {};
export default getItem(localStorage);
